import type { PropsWithChildren } from 'react';

import { Icon } from '@iconify/react';
import { CircleButton } from '@ipen-portal/plugin-common-react';
import { Popover } from '@mui/material';
import { useState } from 'react';

export const FilterMenu = ({ children }: PropsWithChildren) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const showMenu = Boolean(anchorEl);
  const id = showMenu ? 'simple-popover' : undefined;

  return (
    <>
      <CircleButton
        onClick={e => {
          setAnchorEl(e.currentTarget);
        }}
      >
        <Icon icon="ic:baseline-filter-alt" />
      </CircleButton>

      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{
          horizontal: 'right',
          vertical: 'top',
        }}
        id={id}
        keepMounted
        onClose={() => {
          setAnchorEl(null);
        }}
        open={showMenu}
      >
        {children}
      </Popover>
    </>
  );
};
